import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { EditableLabelGroup, WrappingBehavior, ILabelModel } from "azure-devops-ui/Label";
import { getSuggestionsAsync, labelProps } from "./LabelData";

export default class EditableLabelGroupPromises extends React.Component<{}> {
    private ref: React.RefObject<EditableLabelGroup> = React.createRef<EditableLabelGroup>();

    public render() {
        return (
            <div className="flex-column" style={{ width: 400 }}>
                <EditableLabelGroup
                    ref={this.ref}
                    labelProps={labelProps}
                    wrappingBehavior={WrappingBehavior.freeFlow}
                    getSuggestedLabels={getSuggestionsAsync}
                    title={"Labels"}
                    onLabelSubmit={this._onLabelSubmit}
                    onLabelRemove={this._onLabelRemove}
                />
                <Button onClick={this.onButtonClick}>Click to focus</Button>
            </div>
        );
    }

    private onButtonClick = () => {
        this.ref.current!.focus();
    };

    private _onLabelSubmit = (model: ILabelModel) => {
        labelProps.push(model);

        // Simulate a server call to validate the addition
        Promise.resolve(getSuggestionsAsync(model.content)).then(
            (suggestedItems: ILabelModel[]) => {
                // Find a match
                const trueModel: ILabelModel = suggestedItems.filter(
                    (value: ILabelModel) => model.content === value.content
                )[0];

                // Create new array
                if (trueModel) {
                    const newArray: ILabelModel[] = [];

                    // Splice and replace
                    labelProps.value.forEach((value: ILabelModel) => {
                        if (value.content === trueModel.content) {
                            newArray.push(trueModel);
                        } else {
                            newArray.push(value);
                        }
                    });

                    labelProps.value = newArray;
                }
            }
        );
    };

    private _onLabelRemove = (model: ILabelModel) => {
        labelProps.removeAll(
            (item: ILabelModel) => item.content.toUpperCase() === model.content.toUpperCase()
        );
    };
}
